var path = 'admin/templates/fax-referral.html';
var html = "<ui-view></ui-view>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/admin/templates/fax-referral.html
 ** module id = 281
 ** module chunks = 0
 **/